import { render, staticRenderFns } from "./ColorPickerS.vue?vue&type=template&id=4c11b532"
import script from "./ColorPickerS.vue?vue&type=script&lang=ts"
export * from "./ColorPickerS.vue?vue&type=script&lang=ts"
import style0 from "./ColorPickerS.vue?vue&type=style&index=0&id=4c11b532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports